import Body from "./routes/Body";

function App() {
  return <Body></Body>;
}

export default App;
